// 英文語言包
const en = {
  // 導航欄
  nav: {
    features: "Features",
    privacy: "Privacy",
    blog: "Blog",
    help: "Help",
    faq: "FAQ",
    donate: "Donate",
    download: "Download",
  },

  // 主視覺區
  hero: {
    title: "Speak Freely\nLeave No Trace",
    subtitle: "Private messaging through decentralized encryption",
    cta: "Get Vapor",
    platforms: "Available on Android, iOS, Windows, macOS, and Linux.",
    phone: {
      contact: "05df…a3b1",
      status: "Encrypted",
      conversation: [
        { from: "them", text: "Hey! Have you tried Vapor yet?" },
        { from: "me", text: "Just installed it. No phone number needed!" },
        { from: "them", text: "Right? Just an Account ID. Totally anonymous." },
        { from: "me", text: "And everything is end-to-end encrypted?" },
        { from: "them", text: "Yes! Plus onion routing. No one can trace it." },
        { from: "me", text: "Finally a messenger I can trust." },
      ],
    },
  },

  // 產品介紹
  intro: {
    title: "What is Vapor?",
    description:
      "Vapor is an end-to-end encrypted messenger that protects your personal data. Built and maintained by a passionate global community of privacy advocates.",
  },

  // 六大隱私特性
  privacyFeatures: [
    {
      title: "No Phone Numbers",
      description:
        "Keep your identity private with Account IDs No phone number or email required to sign up",
      icon: "🔒",
    },
    {
      title: "No Data Breaches",
      description:
        "Vapor doesn't collect your private data so there's nothing to leak",
      icon: "🛡️",
    },
    {
      title: "Safe Paths",
      description:
        "Onion-routed paths protect your conversations from hackers and eavesdroppers",
      icon: "🧅",
    },
    {
      title: "Open Source",
      description:
        "Privacy is more than a promise Anyone can view audit and contribute to Vapor's code",
      icon: "📖",
    },
    {
      title: "People Powered",
      description:
        "Thousands of nodes run by a global community Vapor is by the people for the people",
      icon: "🌍",
    },
    {
      title: "No Trackers",
      description:
        "Your data is never collected never tracked and never sold to third parties",
      icon: "🚫",
    },
  ],

  // 三大功能區
  features: [
    {
      title: "Speak Freely",
      description:
        "Only you and the person you are speaking to can ever see your messages Enjoy freedom with end-to-end encryption and disappearing messages",
    },
    {
      title: "Stay in Control",
      description:
        "You control messages from start to finish Manage encryption keys or choose custom themes — Vapor puts you in charge",
    },
    {
      title: "Privacy for Your Crowd",
      description:
        "Secure group and community chats for 100+ members make organizing with friends or events effortless",
    },
  ],

  // 功能區手機內容
  featurePhones: {
    chat: {
      name: "7c2e…f904",
      status: "Encrypted",
      messages: [
        { from: "them", text: "Hey, is this really private?" },
        { from: "me", text: "End-to-end encrypted. Only we can read this." },
        { from: "them", text: "No phone number needed?" },
        { from: "me", text: "Nope. Just an Account ID." },
        { from: "them", text: "That's amazing! No metadata at all?" },
        { from: "me", text: "Zero. Messages vanish after you read them." },
      ],
      tag: "End-to-End Encrypted",
    },
    settings: {
      title: "Settings",
      items: {
        encryptionKeys: "Encryption Keys",
        verified: "Verified",
        disappearing: "Disappearing Messages",
        onionRouting: "Onion Routing",
        notifications: "Notifications",
        theme: "Theme",
        themeVal: "Light",
        linkedDevices: "Linked Devices",
        screenLock: "Screen Lock",
        recoveryEmail: "Recovery Email",
        set: "Set",
      },
    },
    group: {
      name: "Vapor Community",
      members: "100 members",
      messages: [
        { from: "9a1f…de07", color: "#00d46a", text: "Welcome everyone! This group is fully encrypted." },
        { from: "b4c8…6e3a", color: "#61F78D", text: "100+ members and still private. Amazing!" },
        { from: "me", text: "Love the community features here." },
        { from: "e72d…41fc", color: "#00b35a", text: "Decentralized and open source. The future!" },
        { from: "me", text: "No ads, no tracking. Just pure privacy." },
        { from: "9a1f…de07", color: "#00d46a", text: "Share the invite link with friends!" },
      ],
      inputPlaceholder: "Message...",
    },
  },

  // 號召行動區
  callToAction: {
    title: "No ads No trackers\nNo compromise",
    description:
      "Vapor is free and open source Built by a community that believes privacy is a fundamental right",
    cta: "Get Vapor",
  },

  // 電子報訂閱
  newsletter: {
    title: "Stay Updated",
    description:
      "Every update on digital privacy, delivered straight to your inbox.",
    placeholder: "Enter your email",
    button: "Subscribe",
  },

  // 頁腳
  footer: {
    about: "About",
    changelog: "Changelog",
    privacyPolicy: "Privacy Policy",
    terms: "Terms of Service",
    blog: "Blog",
    faq: "FAQ",
    community: "Community",
    contactUs: "Contact Us",
    companyName: "Vapor Technology Co., Ltd.",
    address: "12F, No. 50, Sec. 4, Nanjing E. Rd., Songshan Dist., Taipei 105, Taiwan",
  },
};

export default en;
